/* IW Collection (iwc-*) — filter chips, sort, compare pickers and the restock popup.
   Add to bag is handled by the theme's <form is="product-form"> (cart drawer). */
(() => {
  if (window.__iwcLoaded) return;
  window.__iwcLoaded = true;

  /* ---------- Filter chips + sort ---------- */
  function initGrid(root) {
    const grid = root.querySelector('[data-iwc-grid]');
    if (!grid || grid.dataset.ready) return;
    grid.dataset.ready = '1';

    const cards = [...grid.querySelectorAll('[data-iwc-card]')];
    const chips = [...root.querySelectorAll('[data-iwc-filter]')];
    const sort = root.querySelector('[data-iwc-sort]');
    const spotlight = root.querySelector('[data-iwc-spotlight]');
    const count = root.querySelector('[data-iwc-count]');
    const noun = root.querySelector('[data-iwc-noun]');
    const allNote = root.querySelector('[data-iwc-all-note]');
    const clear = root.querySelector('[data-iwc-clear]');
    const empty = root.querySelector('[data-iwc-empty]');
    const cap = Number(root.dataset.priceCap) || Infinity;
    let filter = 'all';

    const test = {
      all: () => true,
      best: (c) => c.dataset.best === 'true',
      price: (c) => Number(c.dataset.price) < cap,
      stock: (c) => c.dataset.available === 'true'
    };

    function apply() {
      const order = sort ? sort.value : 'featured';
      const sorted = cards.slice().sort((a, b) => {
        if (order === 'price-asc') return a.dataset.price - b.dataset.price;
        if (order === 'price-desc') return b.dataset.price - a.dataset.price;
        return a.dataset.index - b.dataset.index;
      });
      let shown = 0;
      sorted.forEach((card) => {
        grid.appendChild(card);
        const on = test[filter](card);
        card.hidden = !on;
        if (on) {
          shown += 1;
          const idx = card.querySelector('[data-iwc-index]');
          if (idx) idx.textContent = String(shown).padStart(2, '0');
        }
      });
      chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.iwcFilter === filter)));
      if (spotlight) spotlight.hidden = filter !== 'all';
      if (count) count.textContent = shown;
      if (noun) noun.textContent = shown === 1 ? noun.dataset.one : noun.dataset.many;
      if (allNote) allNote.hidden = filter !== 'all';
      if (clear) clear.hidden = filter === 'all';
      if (empty) empty.hidden = shown > 0;
    }

    chips.forEach((chip) => chip.addEventListener('click', () => { filter = chip.dataset.iwcFilter; apply(); }));
    if (clear) clear.addEventListener('click', () => { filter = 'all'; apply(); });
    if (sort) sort.addEventListener('change', apply);
  }

  /* ---------- Compare ---------- */
  function initCompare(root) {
    if (root.dataset.ready) return;
    const dataEl = root.querySelector('[data-iwc-compare-data]');
    if (!dataEl) return;
    root.dataset.ready = '1';
    let bags = [];
    try { bags = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const byHandle = Object.fromEntries(bags.map((b) => [b.handle, b]));
    const picks = [...root.querySelectorAll('[data-iwc-pick]')];

    function render() {
      picks.forEach((select, side) => {
        const bag = byHandle[select.value];
        if (!bag) return;
        const col = root.querySelector(`[data-iwc-col="${side}"]`);
        const img = col.querySelector('img');
        if (img) {
          if (bag.image) { img.src = bag.image; img.alt = bag.title; img.hidden = false; } else { img.hidden = true; }
        }
        col.querySelector('h3').textContent = bag.title;
        const price = col.querySelector('strong');
        if (price) price.textContent = bag.price;
        root.querySelectorAll(`[data-iwc-cell="${side}"]`).forEach((cell) => {
          cell.textContent = bag.values[Number(cell.dataset.row)] || '';
        });
        const view = root.querySelector(`[data-iwc-view="${side}"]`);
        if (view) { view.href = bag.url; view.textContent = `${view.dataset.prefix} ${bag.title}`.trim(); }
      });
    }

    picks.forEach((select) => select.addEventListener('change', render));
    root.iwcSetPair = (handles) => {
      handles.forEach((h, i) => { if (picks[i] && byHandle[h]) picks[i].value = h; });
      render();
    };
    render();
  }

  // "Compare Stride editions" in the spotlight: preselect the pair, then scroll.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-iwc-compare-pair]');
    if (!link) return;
    const compare = document.querySelector('[data-iwc-compare]');
    if (!compare) return;
    event.preventDefault();
    if (compare.iwcSetPair) compare.iwcSetPair(link.dataset.iwcComparePair.split(',').filter(Boolean));
    compare.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  /* ---------- Restock popup ---------- */
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-iwc-notify]');
    if (open) {
      const dialog = document.querySelector('[data-iwc-notify-dialog]');
      if (!dialog) return;
      dialog.querySelector('[data-iwc-notify-name]').textContent = open.dataset.title;
      dialog.querySelector('[data-iwc-notify-tags]').value = `restock,restock-${open.dataset.handle}`;
      dialog.showModal();
      return;
    }
    if (event.target.closest('[data-iwc-dialog-close]')) {
      event.target.closest('dialog').close();
      return;
    }
    // Click on the backdrop closes the popup.
    const dialog = event.target.matches && event.target.matches('[data-iwc-notify-dialog]') ? event.target : null;
    if (dialog) {
      const r = dialog.getBoundingClientRect();
      const outside = event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
      if (outside) dialog.close();
    }
  });

  function init(scope = document) {
    scope.querySelectorAll('[data-iwc-collection]').forEach(initGrid);
    scope.querySelectorAll('[data-iwc-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
